import { useContext, useEffect } from 'react';
// Context
import {
  airportContext,
  countryContext,
  FIRContext,
  makeAndModelContext,
  aircraftContext,
  airwayContext,
} from '../Context';

export const useCleanPersistentData = () => {
  const { setAirport } = useContext(airportContext);
  const { setCountry } = useContext(countryContext);
  const { setFIR } = useContext(FIRContext);
  const { setMakeAndModel } = useContext(makeAndModelContext);
  const { setAircraft } = useContext(aircraftContext);
  const { setAirway } = useContext(airwayContext);

  useEffect(() => {
    localStorage.setItem('current_country', null);
    localStorage.setItem('current_airport', null);
    localStorage.setItem('current_fir', null);
    localStorage.setItem('current_make_model', null);
    localStorage.setItem('current_aircraft', null);
    localStorage.setItem('current_airway', null);
    setCountry(false);
    setAirport(false);
    setFIR(false);
    setMakeAndModel(false);
    setAircraft(false);
    setAirway(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
